import { getMiniCart, showMiniCart } from './mda-mini-cart';

// AJAX ADD TO CART
(function ($) {
    function validateRequiredAccessories(options = {}) {
        const settings = {
            scroll: typeof options.scroll === 'boolean' ? options.scroll : true,
            decorate:
                typeof options.decorate === 'boolean' ? options.decorate : true,
        };

        const $requiredItems = $('.configurator__item');
        const $requiredNotSelected = $requiredItems.filter(function () {
            return (
                $(this).find('.configurator__name-required').length > 0 &&
                !$(this).hasClass('is-active')
            );
        });

        $requiredItems.removeClass('has-error').css('border', 'none');
        $('.required-warning').remove();

        if ($requiredNotSelected.length > 0) {
            const $firstInvalid = $requiredNotSelected.first();

            if (settings.decorate) {
                $firstInvalid
                    .addClass('has-error')
                    .css('border', '1px solid #d50057');
            }

            if (settings.scroll) {
                $('html, body').animate(
                    {
                        scrollTop: $firstInvalid.offset().top - 100,
                    },
                    500
                );
            }

            return false;
        }

        return true;
    }

    // Product listing add to cart button

    $("input[name='quantity']").on('input', function () {
        var max = parseInt($(this).attr('max'));
        var value = parseInt($(this).val());

        if (max) {
            if (value > max) {
                $('.single_add_to_cart_button').addClass('-disabled');
            } else {
                $('.single_add_to_cart_button').removeClass('-disabled');
            }
        }
    });

    $(document).ready(function ($) {
        $('form.cart').on('keyup keypress', function (e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                e.preventDefault();
                return false;
            }
        });
    });

    $(document).on('click', '.js-single-add-to-cart', function (e) {
        e.preventDefault();

        if (!validateRequiredAccessories()) {
            if (typeof i18n !== 'undefined' && i18n.requiredAccessories) {
                alert(i18n.requiredAccessories);
            }
            return false;
        }

        const button = $(this);
        let product_id = button.val();
        let quantity = $('body').find('[name="quantity"]').val();
        let price = $('body').find('[name="addon-updated_price"]').val();
        let user_label = $('body').find('[name="addon-user_label"]').val();
        let user_comment = $('body').find('[name="addon-user_comment"]').val();
        let non_prefabricated = $('body')
            .find('[name="addon-non_prefabricated"]')
            .val();
        let accessories = $('body')
            .find('[name="addon-configurator_accesories"]')
            .val();

        let accessories_pattern = $('body')
            .find('[name="addon-configurator_accesories_pattern"]')
            .val();

        if (!product_id || price == 0) return;

        addToCart({
            button: button,
            productId: product_id,
            qty: quantity,
            additionalData: {
                updated_price: price,
                configurator_accesories: accessories,
                user_label: user_label,
                user_comment: user_comment,
                non_prefabricated: non_prefabricated,
                configurator_accesories_pattern: accessories_pattern,
            },
        });
    });

    // Variation
    $(document).on('click', '.js-variation-add-to-cart', function (e) {
        e.preventDefault();

        const button = $(this);
        let product_id = $('body').find('[name="product_id"]').val();
        let variation_id = $('body').find('[name="variation_id"]').val();
        let quantity = $('body').find('[name="quantity"]').val();
        let price = $('body').find('[name="addon-updated_price"]').val();
        let user_label = $('body').find('[name="addon-user_label"]').val();
        let user_comment = $('body').find('[name="addon-user_comment"]').val();
        let non_prefabricated = $('body')
            .find('[name="addon-non_prefabricated"]')
            .val();
        let accessories = $('body')
            .find('[name="addon-configurator_accesories"]')
            .val();

        let accessories_pattern = $('body')
            .find('[name="addon-configurator_accesories_pattern"]')
            .val();

        if (variation_id == 0 || product_id == 0 || price == 0) return;

        addToCart({
            button: button,
            productId: product_id,
            qty: quantity,
            variationId: variation_id,
            additionalData: {
                updated_price: price,
                configurator_accesories: accessories,
                user_label: user_label,
                user_comment: user_comment,
                non_prefabricated: non_prefabricated,
                configurator_accesories_pattern: accessories_pattern,
            },
        });
    });

    const loadingClass = 'is-loading';
    const productContentId = 'js-product-container';
    function addToCart({
        action = 'mda_add_to_cart',
        button,
        productId,
        qty,
        variationId = false,
        additionalData = {},
        additionalDataPattern = {},
    }) {
        $('body')
            .find('#' + productContentId)
            .addClass(loadingClass);
        $('body').find('.bottom-bar').addClass('on-loading');
        $.ajax({
            url: base_url + '/wp-json/wc/v3/shop/cart-add-item',
            data: {
                action: action,
                product_id: productId,
                qty: qty,
                variation_id: variationId,
                additional_data: additionalData,
                additional_data_pattern: additionalDataPattern,
            },
            type: 'post',
            success: function (response) {
                $(document).trigger('added_to_cart');
                getMiniCart();
                showMiniCart();
                $('body')
                    .find('#' + productContentId)
                    .removeClass(loadingClass);
                $('body').find('.bottom-bar').removeClass('on-loading');
            },
        });
    }

    // function handleAjaxBeforeSend(button) {
    //     button.parents('.js-product-box').block({
    //         message: null,
    //         overlayCSS: {
    //             background: '#fff',
    //             opacity: 0.6,
    //         },
    //     });
    //     button.addClass('is-loading').addClass('-disabled');
    //     showHeaderSticky();
    // }

    // function handleAjaxSuccess(response, button) {
    //     button.removeClass('is-loading').removeClass('-disabled');
    //     button.parents('.js-product-box').unblock();

    //     if (response.status == 'ok') {
    //         if (button.hasClass('-add-to-cart-small')) {
    //             button.addClass('is-done');
    //         } else {
    //             button.text('Produkt dodany').addClass('is-done');
    //         }

    //         $(document).trigger('added_to_cart'); // UPDATE MINI CART

    //         if (button.hasClass('-add-to-cart-small')) {
    //             window.setTimeout(function () {
    //                 button.removeClass('is-done');
    //             }, 2000);
    //         } else {
    //             window.setTimeout(function () {
    //                 button.text('Do koszyka').removeClass('is-done');
    //             }, 2000);
    //         }

    //         // WP Fragments render
    //         renderFragments(response);

    //         // Open mini cart
    //         if (window.innerWidth > 1024) {
    //             showMiniCart();
    //         }
    //     }

    //     if (response.status == 'error' && response.message) {
    //         var alert_data = {
    //             type: 'alert:show',
    //             title: response.message,
    //             text: response.text,
    //             error: true,
    //         };
    //         $('body').trigger(alert_data);
    //     }
    // }
})(jQuery);
